module.exports = __webpack_public_path__ + "img/headingEle.a5942653.svg";